import { FormRow, ObjectFieldDTO } from '@types'

export const getDisabledWhenScriptConfig = (
  objectFieldsForFilter: ObjectFieldDTO[] | undefined,
  fields: FormRow[] | undefined
) => {
  const srcObjChildren =
    objectFieldsForFilter?.map(field => ({
      key: `srcObj.${field.name}`,
      name: field.desc ?? field.name,
    })) ?? []
  const formValuesChildren =
    fields?.map(field => ({
      key: `formValues.${field.code}`,
      name: field.title,
    })) ?? []
  const currentRowValuesChildren =
    fields?.map(field => ({
      key: `currentRowValues.${field.code}`,
      name: `${field.title} (id)`,
    })) ?? []

  return {
    fieldsInfo: [
      {
        key: 'srcObj',
        name: 'srcObj',
        children: srcObjChildren,
      },
      {
        key: 'rowData',
        name: 'rowData',
      },
      {
        key: 'formValues',
        name: 'formValues',
        children: formValuesChildren,
      },
      {
        key: 'currentRowValues',
        name: 'currentRowValues',
        children: currentRowValuesChildren,
      },
      {
        key: 'formVariables',
        name: 'formVariables',
      },
      {
        key: 'outerVariables',
        name: 'outerVariables',
      },
      {
        key: 'enrichedObject',
        name: 'enrichedObject',
      },
    ],
    variables: [
      {
        name: 'srcObj',
        type:
          objectFieldsForFilter?.map(field => ({
            name: field.name,
            type: field.valueType,
            description: field.desc ?? field.name,
          })) ?? [],
      },
      {
        name: 'formValues',
        type:
          fields?.map(field => ({
            name: field.code,
            type: field.valueType ?? 'any',
            description: field.title,
          })) ?? [],
      },
      {
        name: 'currentRowValues',
        type:
          fields?.map(field => ({
            name: field.code,
            type: field.valueType ?? 'any',
            description: `${field.title} (flattened id)`,
          })) ?? [],
      },
      {
        name: 'formVariables',
        type: 'any',
      },
      {
        name: 'outerVariables',
        type: 'any',
      },
    ],
  }
}
